import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatActionBarDefaultVariants = {}
const chatActionBarCompoundVariants = []

const chatActionBarSlotNames = [
  [
    "root",
    "chatActionBar__root"
  ]
]
const chatActionBarSlotFns = /* @__PURE__ */ chatActionBarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatActionBarDefaultVariants, getSlotCompoundVariant(chatActionBarCompoundVariants, slotName))])

const chatActionBarFn = memo((props = {}) => {
  return Object.fromEntries(chatActionBarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatActionBarVariantKeys = []
const getVariantProps = (variants) => ({ ...chatActionBarDefaultVariants, ...compact(variants) })

export const chatActionBar = /* @__PURE__ */ Object.assign(chatActionBarFn, {
  __recipe__: false,
  __name__: 'chatActionBar',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatActionBarVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, chatActionBarVariantKeys)
  },
  getVariantProps
})